import { useEffect, useState } from 'react';
import { WbButton, WbHeading, WbIcon, WbModal, WbText } from '@workbench/react';
import './VimdtModal.scss';

const subscribers = new Set();

/**
 * Imperative modal API (`showModal({...})`) backed by a single declarative host
 * that must be rendered once inside the Vimdt page tree.
 */
export function showModal(config) {
	subscribers.forEach((notify) => notify(config));
}

const ICONS = {
	info: 'bds/information/24',
	success: 'bds/checkmark/24',
	error: 'bds/alert/24',
	warning: 'bds/alert/24',
	confirm: 'bds/alert/24',
};

export function VimdtModalHost() {
	const [config, setConfig] = useState(null);

	useEffect(() => {
		subscribers.add(setConfig);
		return () => subscribers.delete(setConfig);
	}, []);

	if (!config) return null;

	const { modalType = 'info', title, content, okText, cancelText, onOk, onCancel } = config;
	const showCancel = modalType === 'confirm' && cancelText;

	const close = () => setConfig(null);

	return (
		<WbModal
			open
			scrollLock
			closeOnEscapeKey
			closeOnBackdropClick
			size="s"
			onWbclose={() => {
				close();
				if (onCancel) onCancel();
			}}
			data-testid="vimdt-modal"
		>
			<div className="vimdt-modal__body">
				<div className="vimdt-modal__header">
					<WbIcon name={ICONS[modalType] || ICONS.info} aria-hidden="true" />
					<WbHeading size="s">{title}</WbHeading>
				</div>
				<WbText size="s">{content}</WbText>
				<div className="vimdt-modal__actions">
					{showCancel && (
						<WbButton
							variant="secondary"
							size="s"
							onClick={() => {
								close();
								if (onCancel) onCancel();
							}}
						>
							{cancelText}
						</WbButton>
					)}
					<WbButton
						variant="primary"
						size="s"
						onClick={() => {
							close();
							if (onOk) onOk();
						}}
					>
						{okText}
					</WbButton>
				</div>
			</div>
		</WbModal>
	);
}

export default showModal;
